"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5431],{

/***/ 89046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgPricingInfoIcon = function SvgPricingInfoIcon(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#333",
        fillRule: "nonzero",
        d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16m.5-3.892c0 .251-.224.454-.5.454s-.5-.203-.5-.454V7.392c0-.251.224-.455.5-.455s.5.204.5.455zm-.469-6.483a.781.781 0 1 1 0-1.562.781.781 0 0 1 0 1.562M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgPricingInfoIcon);


/***/ }),

/***/ 66713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pricing_action_button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/pricing-service.js + 2 modules
var pricing_service = __webpack_require__(15650);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var new_button_button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/pricing/pricing-page/contact-us-link-service.js
var contact_us_link_service = __webpack_require__(4442);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./client/services/exceptions-handling-service/exceptions-handling-service.js
var exceptions_handling_service = __webpack_require__(53989);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-action-button/pricing-action-button.scss.js


var StyledPricingSignupButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1oum1930"
})("@media (max-width:", "".concat(vp_sizes/* XXS */.Mp, "px"), '){.pricing-signup-button{input.signup-input[name="email"]{padding:6px;width:100%;margin-left:-10%;}}.try-cta{button.signup-button.ladda-button.xs{padding:8px;margin-bottom:12px;margin-left:-10%;}}}@media (max-width:', vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, '){.pricing-signup-button{input.signup-input[name="email"]{min-width:unset;}}}');
var StyledPricingContactUsButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1oum1931"
})("@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){button.pricing-contact-us-button.xs{padding:8px 32px;}}@media (max-width:", "".concat(vp_sizes/* XXS */.Mp, "px"), "){button.pricing-contact-us-button.xs{padding:12px 16px;margin-bottom:18px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-action-button/default-props.js

/* harmony default export */ var default_props = ({
    userCount: "3",
    signupButtonText: "Try for free",
    contactUsButtonText: "Contact us",
    plan: {
        tier: pricing/* TIERS.BASIC */.Iy.BASIC
    },
    placement: "prices-and-features-card"
});

// EXTERNAL MODULE: ./services/typeform/typeform-service.js
var typeform_service = __webpack_require__(15728);
// EXTERNAL MODULE: ./constants/typeform-contact-sales.js
var typeform_contact_sales = __webpack_require__(13979);
// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-action-button/pricing-action-button.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



















var PricingActionButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PricingActionButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PricingActionButton);
    function PricingActionButton(props) {
        (0,_class_call_check/* default */.Z)(this, PricingActionButton);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onContactUsClicked", function() {
            var _props = _this.props, abTests = _props.abTests, userCount = _props.userCount, plan = _props.plan, placement = _props.placement, isTypeformDisabled = _props.isTypeformDisabled;
            BigBrain("track", bigbrain_event_types.CONTACT_US_BUTTON_CLICKED, {
                placement: placement,
                source: bigbrain_event_types.HP_SOURCE,
                info1: plan.tier,
                info2: userCount
            });
            var shouldShowTypeform = !isTypeformDisabled && (0,monetization_ab_tests_service/* shouldShowTypeformContactUs */.RT)({
                abTests: abTests
            });
            if (shouldShowTypeform) {
                _this.displayTypeform();
            } else {
                _this.redirectToSalesPage();
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "redirectToSalesPage", function() {
            var _props = _this.props, plan = _props.plan, clusterConfig = _props.clusterConfig, abTests = _props.abTests, forcePricing = _props.forcePricing, cookies = _props.cookies;
            window.location = (0,contact_us_link_service/* getPricingContactUsLink */.p)(plan.tier, clusterConfig, abTests, cookies, forcePricing);
        });
        // This is bad copy-paste from use-contact-cales-typeform.js
        // Since it's deprected and will be removed soon, I didn't bother to refactor it
        // The main problem for this copy-paste is the fact that it's class component and no hooks allowed
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "displayTypeform", function() {
            var _props = _this.props, plan = _props.plan, clusterConfig = _props.clusterConfig, abTests = _props.abTests, forcePricing = _props.forcePricing, useNewTypeformUSVariant = _props.useNewTypeformUSVariant, cookies = _props.cookies, forceCurrency = _props.forceCurrency, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, isV13PricingVersion = _props.isV13PricingVersion, testTypeformContactSales = _props.testTypeformContactSales, forceTypeformContactSalesExperience = _props.forceTypeformContactSalesExperience, contactSalesTestMode = _props.contactSalesTestMode;
            var getNewVariantForTest = useNewTypeformUSVariant || (0,acquisition_ab_test_service.shouldUseNewTypeformVariant)(abTests, true);
            var pricingData = {
                forcePricing: forcePricing,
                cookies: cookies,
                abTests: abTests,
                forceCurrency: forceCurrency,
                countryCode: cloudfrontViewerCountry,
                isV13PricingVersion: isV13PricingVersion
            };
            if ((0,typeform_service/* shouldGetTypeformExperience */.ap)({
                abTests: abTests,
                cloudfrontViewerCountry: cloudfrontViewerCountry,
                testTypeformContactSales: testTypeformContactSales,
                forceTypeformContactSalesExperience: forceTypeformContactSalesExperience,
                sendBigBrainEvent: true
            })) {
                try {
                    (0,typeform_contact_sales/* openContactSalesTypeform */._X)({
                        country: cloudfrontViewerCountry,
                        deviceType: typeform_contact_sales/* TYPEFORM_DESKTOP_DEVICE_TYPE */.PM,
                        getNewVariantForTest: getNewVariantForTest,
                        isTest: contactSalesTestMode,
                        pricingData: pricingData
                    });
                } catch (e) {
                    var bbEventParams = {
                        name: bigbrain_event_types.TYPEFORM_UNHANDLED_EXCEPTION
                    };
                    (0,exceptions_handling_service/* handleClientException */.N)({
                        e: e,
                        bbEventParams: bbEventParams
                    });
                    window.location = (0,contact_us_link_service/* getPricingContactUsLink */.p)(plan.tier, clusterConfig, abTests, cookies, forcePricing);
                }
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getContactUsButton", function() {
            var contactUsButtonText = _this.props.contactUsButtonText;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPricingContactUsButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                    onClickCallback: _this.onContactUsClicked,
                    disableAnimation: true,
                    size: new_button_button_component.XS,
                    color: "outline-dark-blue-inverted-hover",
                    className: "pricing-contact-us-button",
                    children: contactUsButtonText
                })
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getRegularSignupButton", function() {
            var _props = _this.props, plan = _props.plan, signupButtonText = _props.signupButtonText, userCount = _props.userCount, billingPeriod = _props.billingPeriod;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPricingSignupButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                    parentSegment: pricing/* PLAN_INFO_SEGMENT_NAME */.Us,
                    buttonSize: new_button_button_component.XS,
                    buttonColor: "outline-indigo-inverted-hover",
                    ctaText: signupButtonText,
                    buttonSource: plan.tier,
                    useCtaText: true,
                    className: "pricing-signup-button",
                    pricingDetails: {
                        tier: plan === null || plan === void 0 ? void 0 : plan.tier,
                        userCount: userCount,
                        billingPeriod: billingPeriod
                    },
                    extraData: {
                        pricing_tier: plan === null || plan === void 0 ? void 0 : plan.tier
                    }
                })
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(PricingActionButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, plan = _props.plan, userCount = _props.userCount, clusterConfig = _props.clusterConfig, abTests = _props.abTests, cookies = _props.cookies, forcePricing = _props.forcePricing;
                var tier = plan.tier;
                return (0,pricing_service/* shouldSeeContactUs */.j)(tier, userCount, {
                    clusterConfig: clusterConfig,
                    abTests: abTests,
                    cookies: cookies,
                    forcePricing: forcePricing
                }) ? this.getContactUsButton() : this.getRegularSignupButton();
            }
        }
    ]);
    return PricingActionButton;
}(react.PureComponent);
/* harmony default export */ var pricing_action_button = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(PricingActionButton)));
PricingActionButton.defaultProps = default_props;


/***/ }),

/***/ 97169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uI": function() { return /* binding */ getPlanFeatures; },
  "Yi": function() { return /* binding */ getPlanValueFeatures; },
  "nO": function() { return /* binding */ translateProductKeyFallbackToCore; }
});

// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js + 5 modules
var clusterized_pricing_page_service = __webpack_require__(69017);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/default_sections.js
var default_sections = __webpack_require__(16168);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/index.js

var getDefaultPricingPageSections = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return (0,default_sections/* getDefaultSections */.VG)({
        cookies: cookies,
        abTests: abTests,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
};

// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/free_tier_essentials.js
var free_tier_essentials = __webpack_require__(8876);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/value-features/index.js
var value_features = __webpack_require__(69078);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./services/pricing-features-service.js








var getPlanValueFeatures = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, clusterId = param.clusterId, clusterConfig = param.clusterConfig, forcePricing = param.forcePricing;
    if (clusterId) {
        var _clusterConfig_payments_view;
        var pricingPageConfig = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : _clusterConfig_payments_view.pricing;
        var valueFeatures = (0,clusterized_pricing_page_service/* getValueFeaturesFromClusterConfig */.A2)(pricingPageConfig === null || pricingPageConfig === void 0 ? void 0 : pricingPageConfig.value_features, {
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier,
            abTests: abTests,
            cookies: cookies
        });
        if (valueFeatures && (0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
            abTests: abTests,
            cookies: cookies,
            forcePricing: forcePricing
        })) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_CLUSTERIZED_INFO_PRESENTED, {
                kind: "user_experience_for_cluster",
                info1: clusterId,
                info2: "payments_view[pricing]",
                data: pricingPageConfig,
                placement: "value_features"
            });
            return valueFeatures;
        }
    }
    // otherwise, returning default values
    return (0,value_features/* getDefaultValueFeatures */.v)({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
};
var getPlanFeatures = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, clusterId = param.clusterId, clusterConfig = param.clusterConfig, forcePricing = param.forcePricing;
    if (clusterId) {
        var _clusterConfig_payments_view;
        var pricingPageConfig = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : _clusterConfig_payments_view.pricing;
        var pricingPageSections = (0,clusterized_pricing_page_service/* getPricingPageSectionsFromClusterConfig */.LF)(pricingPageConfig, {
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
        if (pricingPageSections && (0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
            abTests: abTests,
            cookies: cookies,
            forcePricing: forcePricing
        })) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_CLUSTERIZED_INFO_PRESENTED, {
                kind: "user_experience_for_cluster",
                info1: clusterId,
                info2: "payments_view[pricing]",
                data: pricingPageConfig,
                placement: "pricing_features"
            });
            return pricingPageSections; // successfully retrieved from cluster config.
        }
    }
    // otherwise - no cluster ID, or user wasn't in cluster test -
    // using default sections list, but possibly modifying it to use the free tier essentials:
    var sections = getDefaultPricingPageSections({
        cookies: cookies,
        abTests: abTests,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
    if (hasFreeTier) {
        // pricing pages with free tier have a different essentials list - depending on the free tier version
        var freeTierEssentials = (0,free_tier_essentials/* getFreeTierEssentials */.b)(abTests, cookies);
        sections.splice(0, 1, freeTierEssentials); // inserting the free tier essentials instead of the regular essentials
    }
    return sections;
};
var translateProductKeyFallbackToCore = function(param) {
    var productName = param.productName, key = param.key;
    var translate = (0,react.useContext)(generic_config_context/* GenericConfigContext */.Z).translate;
    var name = translate("pricingPage.products.".concat(productName, ".featuresList.").concat(key));
    if (name.startsWith("pricingPage.products")) {
        return translate("pricingPage.products.core.featuresList.".concat(key));
    }
    return name;
};


/***/ }),

/***/ 56492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OU": function() { return /* binding */ getTierTranslationKey; },
/* harmony export */   "f_": function() { return /* binding */ TIERS_COLORS_MAP; },
/* harmony export */   "kP": function() { return /* binding */ getPlanColor; },
/* harmony export */   "qD": function() { return /* binding */ getPreviousTierNameByTier; },
/* harmony export */   "qY": function() { return /* binding */ getPlans; },
/* harmony export */   "wD": function() { return /* binding */ getPreviousTierName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12573);
/* harmony import */ var _pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69017);
/* harmony import */ var _bigbrain_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65488);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65023);
/* harmony import */ var _pricing_page_clusterization_clusterized_pricing_page_helper_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85920);
/* harmony import */ var _ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46724);









var _obj;
var TIERS_COLORS_MAP = (_obj = {}, // in here, 'tierGeneralColor' is the general indicator of the tier (found at the top of the tier cards),
// 'tierContentColor' should be the color used for displaying content colored with that tier's color, e.g. texts,
// which require better accessibility and contrast.
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].mud */ .Z.mud,
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].mud */ .Z.mud
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["purple-v2"] */ .Z["purple-v2"],
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["purple-v2"] */ .Z["purple-v2"]
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].blue */ .Z.blue,
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].blue */ .Z.blue
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["done-green"] */ .Z["done-green"],
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["accessible-green"] */ .Z["accessible-green"]
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, {
    tierGeneralColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["brand-enterprise-dark"] */ .Z["brand-enterprise-dark"],
    tierContentColor: styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["brand-enterprise-dark"] */ .Z["brand-enterprise-dark"]
}), _obj);
var getPlanColor = function(plan) {
    var isContentColored = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var colorProperty = isContentColored ? "tierContentColor" : "tierGeneralColor";
    return TIERS_COLORS_MAP[plan.tier][colorProperty];
};
var getDefaultPlans = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var basicPlan = {
        displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC),
        tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC
    };
    var plans = [
        {
            displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD),
            tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD
        },
        {
            displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO),
            tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO
        },
        {
            displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE),
            tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE
        }
    ];
    var hideBasic = (0,_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_6__/* .shouldHideBasic */ .gd)({
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing,
        hasStudentPlan: hasStudentPlan
    });
    if (!hideBasic) {
        plans.unshift(basicPlan);
    }
    if (hasFreeTier || hasStudentPlan) {
        plans.unshift({
            displayName: getTierTranslationKey(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, {
                hasStudentPlan: hasStudentPlan
            }),
            tier: constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE
        });
    }
    return plans;
};
var getPlans = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _clusterConfig_payments_view;
    var hasFreeTier = options.hasFreeTier, hasStudentPlan = options.hasStudentPlan, clusterConfig = options.clusterConfig, clusterId = options.clusterId, abTests = options.abTests, cookies = options.cookies, forcePricing = options.forcePricing;
    var plans = getDefaultPlans({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        forcePricing: forcePricing,
        cookies: cookies
    });
    var pricingPageConfig = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : _clusterConfig_payments_view.pricing;
    var ref = pricingPageConfig || {}, clusterPlans = ref.plans;
    var shouldUseHiddenPlans = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(clusterPlans) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_3__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
    if (!shouldUseHiddenPlans) return plans;
    var hiddenPlans = clusterPlans.hidden_plans, tmp = clusterPlans.plan_overrides, planOverrides = tmp === void 0 ? {} : tmp;
    var filteredPlans = plans.filter(function(plan) {
        return !hiddenPlans.includes(plan.tier);
    }).map(function(plan) {
        return (0,_pricing_page_clusterization_clusterized_pricing_page_helper_service__WEBPACK_IMPORTED_MODULE_5__/* .applyOverrides */ .RW)(plan, planOverrides[plan.tier], [
            "displayName"
        ]);
    });
    (0,_bigbrain_service__WEBPACK_IMPORTED_MODULE_4__.trackEvent)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.PRICING_PAGE_CLUSTERIZED_INFO_PRESENTED, {
        kind: "user_experience_for_cluster",
        info1: clusterId,
        info2: "payments_view[pricing]",
        data: hiddenPlans,
        placement: "hidden_plans"
    });
    return filteredPlans;
};
var getPreviousTierName = function(currentTier, plans) {
    var _plans_;
    var index = plans.findIndex(function(plan) {
        return plan.tier === currentTier;
    });
    return (_plans_ = plans[index - 1]) === null || _plans_ === void 0 ? void 0 : _plans_.displayName;
};
var getPreviousTierNameByTier = function(currentTier, tiers) {
    var _tiers_;
    var index = tiers.findIndex(function(tier) {
        return tier === currentTier;
    });
    return index > 0 ? (_tiers_ = tiers[index - 1]) === null || _tiers_ === void 0 ? void 0 : _tiers_.name : undefined;
};
var _obj1;
var TIER_TRANSLATION_KEY_BY_TIER = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, "pricingPage.plans.free.title.name_free"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, "pricingPage.plans.basic.title"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, "pricingPage.plans.standard.title"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, "pricingPage.plans.pro.title"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj1, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, "pricingPage.plans.enterprise.title"), _obj1);
var getTierTranslationKey = function(tierName) {
    var hasStudentPlan = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).hasStudentPlan;
    if (tierName === constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE && hasStudentPlan) {
        return "pricingPage.plans.student.title";
    }
    return TIER_TRANSLATION_KEY_BY_TIER[tierName];
};


/***/ }),

/***/ 4442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ getPricingContactUsLink; }
/* harmony export */ });
/* unused harmony export getDefaultContactUsPageLink */
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69017);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77784);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__);



var DEFAULT_CONTACT_SALES_LINK = "/sales/contact-us?from=pricing&source=Website%20-%20Contact%20Sales";
var ENTERPRISE_CONTACT_SALES_LINK = "/sales/contact-us/enterprise?from=pricing&source=Website%20-%20Contact%20Sales";
var getClusterContactUsLinksByTier = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var contactUsLinks = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.contact_us_links;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(contactUsLinks) && (0,_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return contactUsLinks;
    }
    return {};
};
var getPricingContactUsLink = function(tier, clusterConfig, abTests, cookies, forcePricing) {
    var contactUsLinksByTier = getClusterContactUsLinksByTier(clusterConfig, abTests, cookies, forcePricing);
    var contactUsLink = contactUsLinksByTier[tier];
    return contactUsLink || getDefaultContactUsPageLink(abTests);
};
var getDefaultContactUsPageLink = function(abTests) {
    var sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if ((0,services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__.shouldGetEnterpriseContactUsPageAbTest)(abTests, sendBigBrainEvent)) return ENTERPRISE_CONTACT_SALES_LINK;
    return DEFAULT_CONTACT_SALES_LINK;
};


/***/ }),

/***/ 60004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getPricingDimensions; }
/* harmony export */ });
var PRICING_DIMENSIONS_2_PLANS = {
    tierCards: {
        planWidth: 40
    },
    featuresSection: {
        featureWidth: 40,
        planWidth: 30
    }
};
var PRICING_DIMENSIONS_3_PLANS = {
    tierCards: {
        planWidth: 30
    },
    featuresSection: {
        featureWidth: 28,
        planWidth: 24
    }
};
var PRICING_DIMENSIONS_4_PLANS = {
    tierCards: {
        planWidth: 24
    },
    featuresSection: {
        featureWidth: 24,
        planWidth: 19
    }
};
var PRICING_DIMENSIONS_5_PLANS = {
    tierCards: {
        planWidth: 19,
        topInfoSize: "sm"
    },
    featuresSection: {
        featureWidth: 20,
        planWidth: 16
    }
};
var getPricingDimensions = function(plans) {
    // calculates the size (percentage) of each plan cell in the pricing page, and the feature cell on the left, and returns it.
    // calculation explanation: the desired result is one where (number of plans)*(plan_width) + feature_width = 100.
    switch(plans.length){
        case 2:
            {
                return PRICING_DIMENSIONS_2_PLANS;
            }
        case 3:
            {
                return PRICING_DIMENSIONS_3_PLANS;
            }
        case 4:
            {
                return PRICING_DIMENSIONS_4_PLANS;
            }
        default:
            {
                // 5 tiers
                return PRICING_DIMENSIONS_5_PLANS;
            }
    }
};


/***/ })

}]);